import React from "react";
// import TokenHeader from "./TokenHeader";
import TokenTabs from "./TokenTabs";
import TokenHeader from "../TokenHeader/TokenHeader";

const TokenContainer = ({ children }) => {
  return (
    <main className="float-top position-relative">
      <section>
        <div className="container">
          {/* <TokenHeader /> */}
          {children}
        </div>
      </section>
    </main>
  );
};

export default TokenContainer;
